import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumDataImportType implements BaseEnumType {
  private static allValues: EnumDataImportType[] = []; // make sure this is top-most
  
  public static supplierManufacturers = new EnumDataImportType(0, "SupplierManufacturers", "enum_data_import_type_supplier_manufacturers");
  public static groups = new EnumDataImportType(1, "Groups", "enum_data_import_type_groups");
  public static products = new EnumDataImportType(2, "Products", "enum_data_import_type_products");
  public static materials = new EnumDataImportType(3, "Materials", "enum_data_import_type_materials");
  public static outlets = new EnumDataImportType(4, "Outlets", "enum_data_import_type_outlets");
  public static productGlCodes = new EnumDataImportType(5, "ProductGlCodes", "enum_data_import_type_product_gl_codes");
  public static outletContacts = new EnumDataImportType(6, "OutletContacts", "enum_data_import_type_outlet_contacts");
  public static groupContacts = new EnumDataImportType(7, "GroupContacts", "enum_data_import_type_group_contacts");
  public static priceListLines = new EnumDataImportType(8, "PriceListLines", "enum_data_import_type_price_list_lines");
  public static leads = new EnumDataImportType(9, "Leads", "enum_data_import_type_leads");
  public static orders = new EnumDataImportType(10, "Orders", "enum_data_import_type_orders");
  public static contactCodes = new EnumDataImportType(11, "ContactCodes", "enum_data_import_type_contact_codes");
  public static tasks = new EnumDataImportType(12, "Tasks", "enum_data_import_type_tasks");
  public static autoAssembledProducts = new EnumDataImportType(13, "AutoAssembledProducts", "enum_data_import_type_auto_assembled_products");
  public static shopifyOrders = new EnumDataImportType(14, "ShopifyOrders", "enum_data_import_type_shopify_orders");
  public static caskVessels = new EnumDataImportType(15, "CaskVessels", "enum_data_import_type_cask_vessels");
  public static stockAvailabilityAndReordering = new EnumDataImportType(16, "StockAvailabilityAndReordering", "enum_data_import_type_stock_availability_and_reordering");
  public static itemPurchaseDetails = new EnumDataImportType(17, "ItemPurchaseDetails", "enum_data_import_type_item_purchase_details");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDataImportType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isSupplierManufacturers() { return this === EnumDataImportType.supplierManufacturers; }
  public isGroups() { return this === EnumDataImportType.groups; }
  public isProducts() { return this === EnumDataImportType.products; }
  public isMaterials() { return this === EnumDataImportType.materials; }
  public isOutlets() { return this === EnumDataImportType.outlets; }
  public isProductGlCodes() { return this === EnumDataImportType.productGlCodes; }
  public isOutletContacts() { return this === EnumDataImportType.outletContacts; }
  public isGroupContacts() { return this === EnumDataImportType.groupContacts; }
  public isPriceListLines() { return this === EnumDataImportType.priceListLines; }
  public isLeads() { return this === EnumDataImportType.leads; }
  public isOrders() { return this === EnumDataImportType.orders; }
  public isContactCodes() { return this === EnumDataImportType.contactCodes; }
  public isTasks() { return this === EnumDataImportType.tasks; }
  public isAutoAssembledProducts() { return this === EnumDataImportType.autoAssembledProducts; }
  public isShopifyOrders() { return this === EnumDataImportType.shopifyOrders; }
  public isCaskVessels() { return this === EnumDataImportType.caskVessels; }
  public isStockAvailabilityAndReordering() { return this === EnumDataImportType.stockAvailabilityAndReordering; }
  public isItemPurchaseDetails() { return this === EnumDataImportType.itemPurchaseDetails; }

  public static getValues(): readonly EnumDataImportType[] {
    return EnumDataImportType.allValues;
  }

  public static getValuesExcept0(): readonly EnumDataImportType[] {
    return EnumDataImportType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDataImportType {
    const found = EnumDataImportType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDataImportType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDataImportType): EnumDataImportType {
    const found = name ? EnumDataImportType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDataImportType - Value not found: ${ name }`);
    }

    return found;
  }
}